import { render } from "./Story.vue?vue&type=template&id=550b3d04&scoped=true"
const script = {}

import "./Story.vue?vue&type=style&index=0&id=550b3d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550b3d04"]])

export default __exports__